var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinancials = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.202 6.4v2.915H15.61V6.4zm-.2 16.361v2.706h-1.593V22.76zm.671-3.346q0-.55-.17-.912a1.64 1.64 0 0 0-.551-.631 5.5 5.5 0 0 0-1.012-.541 21 21 0 0 1-2.355-1.112q-1.012-.571-1.593-1.423-.57-.852-.571-2.214 0-1.243.611-2.165.621-.921 1.704-1.423 1.091-.51 2.514-.51 1.083 0 1.974.32a4.4 4.4 0 0 1 1.543.932q.651.6 1.002 1.483.35.871.35 1.984h-3.376q0-.571-.12-.982a1.8 1.8 0 0 0-.32-.671q-.21-.261-.492-.381a1.4 1.4 0 0 0-.61-.13q-.502 0-.812.22-.311.21-.451.561-.14.35-.14.781 0 .451.15.792.16.33.54.621.382.28 1.043.581a21 21 0 0 1 2.325 1.143q1.02.59 1.603 1.453.59.85.59 2.204 0 1.302-.61 2.224-.612.912-1.704 1.393-1.092.48-2.525.48a7.5 7.5 0 0 1-1.913-.25 5.2 5.2 0 0 1-1.724-.811 4.07 4.07 0 0 1-1.232-1.513q-.46-.942-.461-2.315h3.377q0 .672.16 1.122t.43.722q.282.26.632.38.351.11.731.11.511 0 .832-.2.32-.21.47-.55.162-.352.161-.772"
  })));
};
export default SvgFinancials;